import patientApi from '../../services/patients'
import usgApi from '../../services/usg'
import visitApi from '../../services/visits'
export default {
  async fetchPatients({ commit, state, dispatch }) {
    try {
      dispatch('Loader/showLoader', null, { root: true })
      const { data } = await patientApi.getPatients(state.filters)
      commit('setPatients', data)
    } catch (error) {
      throw new Error(error)
    } finally {
      dispatch('Loader/hideLoader', null, { root: true })
    }
  },
  async getPatient({ commit, dispatch }, { id, selectedVisitId }) {
    try {
      dispatch('Loader/showLoader', null, { root: true })
      commit('setPatient', null)
      const { data } = await patientApi.getPatient(id, {
        visitId: selectedVisitId
      })
      const patientData = data || {}
      commit('setPatient', patientData.patient || null)
      commit('setVisits', patientData.visits)
      commit('setCheckUps', patientData.checkUps)
      commit('setPrescriptions', patientData.prescriptions)
      commit('setVisitCheckups', patientData.visitCheckups)
      commit('setServices', patientData.services)
      commit('setVisitServices', patientData.visitServices)
      commit('setHasCertPassword', Boolean(patientData.hasCertPassword))
      commit('setReferrals', patientData.referrals)
      commit('setProcedures', patientData.procedures)
    } catch (e) {
      throw new Error(e)
    } finally {
      dispatch('Loader/hideLoader', null, { root: true })
    }
  },
  async refreshPrescriptions({ commit }, { id, selectedVisitId }) {
    try {
      const { data } = await patientApi.getPatient(id, {
        visitId: selectedVisitId
      })
      commit('setPrescriptions', data?.prescriptions)
    } catch (e) {
      throw new Error(e)
    }
  },
  setPatientData({ commit }, data) {
    commit('setPatient', data)
  },
  resetPatients({ commit }) {
    commit('setPatients', [])
  },
  setVisitService({ commit }, payload) {
    commit('setVisitServices', payload)
  },
  async importUsgFiles({ dispatch, rootState }, { visitId, patientId }) {
    try {
      await usgApi.importUsg(visitId, rootState.Setting.usg)
      await dispatch('getPatient', { id: patientId, selectedVisitId: visitId })
    } catch (e) {
      throw new Error(e)
    }
  },
  setSelectedVisit({ commit }, payload) {
    commit('setSelectedVisit', payload)
  },
  setVisitVisibility({ commit }, payload) {
    commit('setVisitVisibility', payload)
    commit('setSelectedVisitByVisible')
  },
  setFilters({ commit }, payload) {
    commit('setFilters', payload)
  },
  async fetchVisitDates({ commit, dispatch }, payload) {
    try {
      dispatch('Loader/showLoader', null, { root: true })
      const { data } = await patientApi.getVisitDates(payload)
      commit('setVisitDates', data)
    } catch (e) {
      throw new Error(e)
    } finally {
      dispatch('Loader/hideLoader', null, { root: true })
    }
  },
  async setVisitDate({ commit, state, dispatch }, payload) {
    const [datePart = '', hoursPart = ''] = String(payload?.date ?? '').split(',')
    const [hourStartPart = '', hourEndPart = ''] = hoursPart.split('-')
    const date = datePart.trim()
    const hourStart = hourStartPart.trim()
    const hoursEnd = hourEndPart.trim()
    if (!date || !hourStart || !hoursEnd) return

    dispatch('Loader/showLoader', null, { root: true })
    commit('setVisitDate', payload.date)
    const start = `${date} ${hourStart}`
    const end = `${date} ${hoursEnd}`
    const patientId = payload.patientId || state.patient.id
    try {
      await visitApi.sendNextDayVisit({
        visitId: payload.visitId,
        patientId,
        start,
        end
      })
    } catch (e) {
    } finally {
      dispatch('Loader/hideLoader', null, { root: true })
    }
  },
  setCheckUpsChange({ commit }) {
    commit('setCheckUpsChange')
  },
  addVisitService({ commit }, payload) {
    commit('addVisitService', payload)
  },
  setPlannedPatientId({ commit }, payload) {
    commit('setPlannedPatientId', payload)
  }
}
